module.exports = __webpack_public_path__ + "static/img/BrowserPreview.b17c1227.gif";